import React from 'react'

const Ir1277inp = () => {
  return (
    <div>
      <h1>Ir1277inp.js</h1>
    </div>
  )
}

export default Ir1277inp
